import React, { useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import axios from 'axios';
// Xóa bớt các icon không cần thiết nếu bạn dùng mặc định của Antd

import { useSelector } from 'react-redux'; // Thêm cái này
import useAxios from '../../CustomHooks/useAxios';
const { Title, Paragraph } = Typography;

export default function ForceChangePassword() {
    const { axiosi } = useAxios();
    const [loading, setLoading] = useState(false);
    const user = useSelector((state) => state.loginReducer.user);





    const [form] = Form.useForm(); // Khuyên dùng form instance để dễ quản lý

    function isStrongPwd(password) {
        var regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{10,}/;
        return regExp.test(password);
    }

    // const handleLogout = () => {
    //     // setHideItem("hideItem");

    //     axios.post(
    //         `${process.env.REACT_APP_DOMAIN}/users/logout`,
    //         { user },
    //         {
    //             withCredentials: true,
    //         }
    //     );

    //     localStorage.removeItem(process.env.REACT_APP_LSTOKEN);
    //     // dispatch(
    //     //     loginSlice.actions.setLogin({
    //     //         isLogined: checkLoginStatusInLocalStorage(),
    //     //     })
    //     // );
    //     // dispatch(loginSlice.actions.setWebrtc({ webrtc: "KKKKK" }));

    // };
    // Hàm Logout sạch sẽ
    const handleLogoutFlow = async () => {
        try {
            // Gọi API logout để server xóa Cookie
            await axios.post(
                `${process.env.REACT_APP_DOMAIN}/users/logout`,
                { user },
                { withCredentials: true }
            );
        } catch (e) {
            console.error("Logout error:", e);
        }
        // Xóa sạch LocalStorage
        // localStorage.clear();
        localStorage.removeItem("loginStatus");

        // Reload trang để văng ra màn hình Login
        window.location.reload();
    };

    const onFinish = async (values) => {
        if (values.password !== values.confirmPassword) {
            return message.error("Mật khẩu xác nhận không khớp!");
        }
        if (!isStrongPwd(values.password)) {
            return message.error("Mật khẩu không đủ mạnh. (Cần: 10 ký tự, 1 hoa, 1 thường, 1 số, 1 ký tự đặc biệt).");
        }

        try {
            setLoading(true);
            const res = await axiosi.post(`/users/forceChangePassword`, {
                newPassword: values.password
            });

            message.success(res.data.message || "Thành công! Hệ thống sẽ kích hoạt lại phiên đăng nhập.");

            setTimeout(async () => {
                // handleLogout();
                // localStorage.clear();
                // window.location.reload();
                await handleLogoutFlow();
            }, 2000);

        } catch (error) {
            message.error(error.response?.data?.message || "Lỗi cập nhật mật khẩu. Vui lòng liên hệ Admin.");
            setLoading(false);
        } finally {
            // setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#eef2f5' }}>
            <div style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)', width: '450px' }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <Title level={3} type="danger" style={{ margin: 0 }}>Cảnh Báo Bảo Mật</Title>
                    <Paragraph style={{ marginTop: '10px' }}>Tính năng bảo vệ đã kích hoạt. Bạn bắt buộc phải khai báo mật khẩu mới để tiếp tục phiên làm việc.</Paragraph>
                </div>

                <Form
                    layout="vertical"
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item
                        label="Mật khẩu mới"
                        name="password"
                        rules={[{ required: true, message: 'Nhập mật khẩu!' }]}
                    >
                        {/* Thêm visibilityToggle để đảm bảo tính năng hoạt động */}
                        <Input.Password
                            placeholder="Nhập mật khẩu mới"
                            visibilityToggle={true}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Xác nhận mật khẩu mới"
                        name="confirmPassword"
                        dependencies={['password']}
                        // Giúp validate khớp mật khẩu realtime nếu cần
                        rules={[
                            { required: true, message: 'Xác nhận lại!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Mật khẩu xác nhận không khớp!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            placeholder="Xác nhận lại mật khẩu"
                            visibilityToggle={true}
                        />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" size="large" block loading={loading}

                        disabled={loading} // Khóa cứng nút khi đang xử lý

                        danger
                    >
                        CẬP NHẬT VÀ KHỞI ĐỘNG LẠI
                    </Button>
                </Form>
            </div>
        </div >
    );
}